'use strict';

angular.module('rmRundown')
    .service('selector', require('./rundown_selector'))
    .service('yReader', require('./y_reader'))
    .service('userSettings', require('./user_settings'))
;